export default "__VITE_ASSET__CuHqba4B__"